// Dashboard
import Default from '../Components/Dashboard/Default';

// User app
import AddUser from '../Components/App/Users/AddUser';
import UserList from '../Components/App/Users/UserList';
import EditUser from '../Components/App/Users/EditUser';

// Customer app
import PurchasesDashboard from '../Components/App/Purchases/PurchasesDashboard';
import PurchaseInvoices from '../Components/App/Purchases/PurchaseInvoices';
import PurchaseInvoiceDetail from '../Components/App/Purchases/PurchaseInvoiceDetail';
import PurchaseUpload from '../Components/App/Purchases/PurchaseUpload';
import CostList from '../Components/App/Purchases/CostList';
import AllCustomers from '../Components/App/Customers/AllCustomers';
import AddCustomer from '../Components/App/Customers/AddCustomer';
import EditCustomer from '../Components/App/Customers/EditCustomer';

// Categories
import AllCategories from '../Components/App/Categories/AllCategories';

// E-commerce
import Products from '../Components/App/Ecommerce/Products';
import ProductPage from '../Components/App/Ecommerce/ProductPage';
import AddProduct from '../Components/App/Ecommerce/AddProduct';
import UploadHSN from '../Components/App/Ecommerce/UploadHSN';
import SyncShopifyImages from '../Components/App/Ecommerce/SyncShopifyImages';
import Invoice from '../Components/App/Ecommerce/Invoice';
import OrderHistory from '../Components/App/Ecommerce/OrderHistory';
import AllOrders from '../Components/App/Ecommerce/AllOrders';
import Invoices from '../Components/App/Ecommerce/Invoices';
import PaymentDetails from '../Components/App/Ecommerce/PaymentDetails';
import WeeklyReport from '../Components/App/Ecommerce/WeeklyReport/WeeklyReport';
import ProductSaleReport from '../Components/App/Ecommerce/ProductSaleReport/ProductSaleReport';
import CreditNotes from '../Components/App/Ecommerce/CreditNotes/CreditNotes';
import ProductListContain from '../Components/App/Ecommerce/ProductList';
import UploadOrder from '../Components/App/Ecommerce/OrderHistory/UploadOrder';
import NewOrder from '../Components/App/Ecommerce/NewOrder/NewOrder';

// Settings
import CompanySettings from '../Components/App/Settings/CompanySettings';
import OrderSettings from '../Components/App/Settings/OrderSettings';
import CompanyVatNumbersSettings from '../Components/App/Settings/CompanyVatNumbersSettings';
import CompanyEoriNumbersSettings from '../Components/App/Settings/CompanyEoriNumbersSettings';
import ReportEmails from '../Components/App/Settings/ReportEmails';

// Store Inventory
import StoreInventoryImport from '../Components/App/StoreInventory';

// Inventory
import InventoryList from '../Components/App/Inventory';

// Stores
import StoreFulfillment from '../Components/App/Stores';

// Customer portal
import CustomerDashboard from '../Components/Customer/CustomerDashboard';
import CustomerPlaceOrder from '../Components/Customer/PlaceOrder';
import CustomerMyOrders from '../Components/Customer/MyOrders';
import CustomerInvoicesCreditNotes from '../Components/Customer/InvoicesCreditNotes';
import CustomerMyStores from '../Components/Customer/MyStores';
import CustomerBillingDetails from '../Components/Customer/BillingDetails';

export const routes = [
        // Dashboard
        { path: `/dashboard`, Component: <Default /> },

        // Users
        { path: `/add-user`, Component: <AddUser /> },
        { path: `/user-list`, Component: <UserList /> },
        { path: `/edit-user/:id`, Component: <EditUser /> },

        // Customers
        { path: `/all-customers`, Component: <AllCustomers /> },

        // Purchases — supplier PI costs. Admin-gated on the API; the sidebar
        // hides it for other roles, but these routes are reachable by URL, so
        // each screen shows the API's own "admin only" message rather than a blank page.
        { path: `/purchases`, Component: <PurchasesDashboard /> },
        { path: `/purchases/invoices`, Component: <PurchaseInvoices /> },
        { path: `/purchases/invoices/:id`, Component: <PurchaseInvoiceDetail /> },
        { path: `/purchases/upload`, Component: <PurchaseUpload /> },
        { path: `/purchases/costs`, Component: <CostList /> },
        { path: `/add-customer`, Component: <AddCustomer /> },
        { path: `/app/customers/edit-customer/:id`, Component: <EditCustomer /> },

        // Categories
        { path: `/categories`, Component: <AllCategories /> },

        // Ecommerce
        { path: `/product`, Component: <Products /> },
        { path: `/product-page/:id`, Component: <ProductPage /> },
        { path: `/add-product`, Component: <AddProduct /> },
        { path: `/upload-hsn`, Component: <UploadHSN /> },
        { path: `/sync-shopify-images`, Component: <SyncShopifyImages /> },
        { path: `/new-order`, Component: <NewOrder /> },
        { path: `/upload-order`, Component: <UploadOrder /> },
        { path: `/all-orders`, Component: <AllOrders /> },
        { path: `/invoices`, Component: <Invoices /> },
        { path: `/payment-details`, Component: <PaymentDetails /> },
        { path: `/weekly-report`, Component: <WeeklyReport /> },
        { path: `/product-sale-report`, Component: <ProductSaleReport /> },
        { path: `/credit-notes`, Component: <CreditNotes /> },
        { path: `/orderhistory`, Component: <OrderHistory /> },
        { path: `/invoice`, Component: <Invoice /> },
        { path: `/product-list`, Component: <ProductListContain /> },

        // Settings
        { path: `/settings/company`, Component: <CompanySettings /> },
        { path: `/settings/order-settings`, Component: <OrderSettings /> },
        { path: `/settings/company-vat-numbers`, Component: <CompanyVatNumbersSettings /> },
        { path: `/settings/company-eori-numbers`, Component: <CompanyEoriNumbersSettings /> },
        { path: `/settings/report-emails`, Component: <ReportEmails /> },

        // Store Inventory
        { path: `/store-inventory/import`, Component: <StoreInventoryImport /> },

        // Inventory
        { path: `/inventory`, Component: <InventoryList /> },

        // Stores
        { path: `/stores/fulfillment`, Component: <StoreFulfillment /> },

        // Customer portal
        { path: `/customer/dashboard`, Component: <CustomerDashboard /> },
        { path: `/customer/place-order`, Component: <CustomerPlaceOrder /> },
        { path: `/customer/orders/:orderId/edit`, Component: <CustomerPlaceOrder /> },
        { path: `/customer/orders`, Component: <CustomerMyOrders /> },
        { path: `/customer/invoices`, Component: <CustomerInvoicesCreditNotes /> },
        { path: `/customer/stores`, Component: <CustomerMyStores /> },
        { path: `/customer/billing`, Component: <CustomerBillingDetails /> },
];
